import React,{useEffect,useRef,useState} from 'react';
import {useIsDesktop} from './effects';

export default function CustomCursor(){
  const desktop=useIsDesktop();
  const dotRef=useRef(null);const ringRef=useRef(null);
  const [label,setLabel]=useState('');
  const pos=useRef({x:0,y:0});const ring=useRef({x:0,y:0});const raf=useRef(null);
  useEffect(()=>{
    if(!desktop){document.body.classList.remove('hide-native-cursor');return;}
    document.body.classList.add('hide-native-cursor');
    const move=(e)=>{pos.current={x:e.clientX,y:e.clientY};if(dotRef.current){dotRef.current.style.transform=`translate(${e.clientX}px,${e.clientY}px) translate(-50%,-50%)`;}
      const t=e.target.closest('[data-cursor],a,button');
      if(t){const c=t.getAttribute&&t.getAttribute('data-cursor');const map={go:'GO →',play:'PLAY',discover:'KEŞFET',see:'GÖR'};setLabel(map[c]||'');ringRef.current&&ringRef.current.classList.add('hovering');}
      else{setLabel('');ringRef.current&&ringRef.current.classList.remove('hovering');}
    };
    const loop=()=>{ring.current.x+=(pos.current.x-ring.current.x)*0.18;ring.current.y+=(pos.current.y-ring.current.y)*0.18;if(ringRef.current){ringRef.current.style.transform=`translate(${ring.current.x}px,${ring.current.y}px) translate(-50%,-50%)`;}raf.current=requestAnimationFrame(loop);};
    window.addEventListener('mousemove',move);loop();
    return()=>{window.removeEventListener('mousemove',move);cancelAnimationFrame(raf.current);document.body.classList.remove('hide-native-cursor');};
  },[desktop]);
  if(!desktop)return null;
  return <><div ref={dotRef} className="cursor-dot"/><div ref={ringRef} className="cursor-ring">{label}</div></>;
}
